import { $, c as createElementIfNotDefined, n as nextTick, g as getDocument, i as isObject, S as Swiper, N as Navigation, M as Mousewheel, a as Scrollbar } from "./scrollbar.chunk.js";
document.addEventListener("click", modalHandler);
function modalHandler(evt) {
  const modalBtnOpen = evt.target.closest(".tr-modal-open");
  if (modalBtnOpen) {
    const modalSelector = modalBtnOpen.dataset.id;
    showModal(document.querySelector(modalSelector));
  }
  const modalBtnClose = evt.target.closest(".tr-modal-close");
  if (modalBtnClose) {
    evt.preventDefault();
    hideModal(modalBtnClose.closest(".tr-modal"));
  }
}

function showModal(modalElem) {
  modalElem.classList.add("show");
  document.body.style.overflow = "hidden";
}
function hideModal(modalElem) {
  modalElem.classList.remove("show");
  document.body.style.overflow = "auto";
}
async function setModalContent(section, productId, isBundlePage, selectedColor) {
  var _a;
  const isDOMElmt = section[0] == "#";
  const html = isDOMElmt ? ((_a = document.querySelector(section)) == null ? void 0 : _a.innerHTML) : await getSectionHTML(section, productId);
  let jollyModalProduct = document.querySelector("jolly-modal-product");
  document.getElementById("jolly-modal-product").innerHTML = html;
  //document.getElementById("tr-modal-shadow").classList.remove("tr-hidden");
  jollyModalProduct.classList.remove("tr-translate-y-full");
  jollyModalProduct.classList.add("tr-translate-y-0");
  jollyModalProduct.querySelector(".tr-bundle-item-add").setAttribute("disabled", "disabled");
  if (typeof selectedColor !== "undefined") {
    jollyModalProduct.querySelector("[value*=" + selectedColor + "]").checked = true;
  }
  jollyModalProduct.querySelectorAll('[name*="TAILLE"]').forEach((element) => {
    element.addEventListener("click", () => {
      if (!element.classList.contains("disabled")) {
        element.closest(".jolly-bundle-card").querySelector(".tr-bundle-item-add").removeAttribute("disabled");
        element.closest(".jolly-bundle-card").querySelector(".tr-bundle-item-add").innerHTML = window.variantStrings.addToCart;
      } else {
        element.closest(".jolly-bundle-card").querySelector(".tr-bundle-item-add").setAttribute("disabled", "disabled");
        element.closest(".jolly-bundle-card").querySelector(".tr-bundle-item-add").innerHTML = window.variantStrings.selectSize;
      }
      setTimeout(() => {
        let variantId = jollyModalProduct.querySelector('[name="id"]').value;
        let variantPreorder = jollyModalProduct.querySelector('[data-variant-id="' + variantId + '"]');
        jollyModalProduct.querySelectorAll("[data-variant-id]").forEach((element2) => {
          element2.classList.add("tr-hidden");
        });
        if (variantPreorder) {
          variantPreorder.classList.remove("tr-hidden");
          jollyModalProduct.querySelector('[name="add"] > span').classList.add("tr-hidden");
          jollyModalProduct.querySelector(".preorder-text").classList.remove("tr-hidden");
        } else {
          jollyModalProduct.querySelector('[name="add"] > span').classList.remove("tr-hidden");
          jollyModalProduct.querySelector(".preorder-text").classList.add("tr-hidden");
        }
      });
    });
  });
  if (isBundlePage == "true") {
    jollyModalProduct.classList.add("bundle-page");
  }
}
async function getSectionHTML(sectionId, productId) {
  return new Promise(function (resolve, reject) {
    const query = "id:" + productId;
    const qq = productId ? "&q=" + query : "";
    const url = "/search/?sections=" + sectionId + qq;
    fetch(url).then(function (r) {
      r.json().then(function (res) {
        var keys = Object.keys(res);
        if (keys.length > 0) {
          return resolve(res[keys[0]]);
        }
        return reject();
      });
    });
  });
}
if (!customElements.get("jolly-product-card")) {
  customElements.define(
    "jolly-product-card",
    class JollyProductCard extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          colorInputs: this.querySelectorAll('[name*="COULEUR"]'),
          radioSizeInputs: this.querySelectorAll('input[name*="TAILLE"]'),
          addButton: this.querySelector('button[name="add"]'),
          addButtonText: this.querySelector('button[name="add"] > span'),
          addMobileCard: this.querySelectorAll(".tr-mobile-cart-item-add"),
        };
        let isChecked = false;
        this.checkSizeInputs(isChecked);
        this.elements.addMobileCard.forEach((element) => {
          element.addEventListener("click", (event) => {
            event.preventDefault();
            let productId = this.getAttribute("jolly-card-id");
            let section = this.querySelector(".jolly-card-section").dataset.section;
            let isBundlePage = this.querySelector(".jolly-card-section").dataset.bundle || "false";
            let selectedInputColor;
            let selectedColor;
            if (this.querySelector('[name*="COULEUR"]:checked')) {
              selectedInputColor = this.querySelector('[name*="COULEUR"]:checked').value || "";
              selectedColor = selectedInputColor.split(" ")[0];
            }
            setModalContent(section, productId, isBundlePage, selectedColor);
          });
        });
        this.querySelectorAll('[name*="TAILLE"]').forEach((element) => {
          element.addEventListener("change", () => {
            if (!element.classList.contains("disabled")) {
              element.closest(".jolly-card").querySelector('[name="add"]').removeAttribute("disabled");
            } else {
              element.closest(".jolly-card").querySelector('[name="add"]').setAttribute("disabled", "disabled");
            }
          });
        });
        this.elements.colorInputs.forEach((element) => {
          element.addEventListener("change", () => {
            element
              .closest(".jolly-card")
              .querySelectorAll('[name*="TAILLE"]:checked')
              .forEach((input) => {
                input.checked = false;
              });
            let inputName = element.value.split(" • ");
            let currentImage = element.closest(".jolly-card").querySelector('[jolly-img="' + inputName[0] + '"]');
            let allImages = element.closest(".jolly-card").querySelectorAll("[jolly-img]");
            allImages.forEach((image) => {
              image.classList.remove("active");
            });
            currentImage.classList.add("active");
            this.checkSizeInputs(isChecked);
          });
        });
      }
      checkSizeInputs(isChecked) {
        for (let i = 0; i < this.elements.radioSizeInputs.length; i++) {
          if (this.elements.radioSizeInputs[i].checked) {
            isChecked = true;
            break;
          }
        }
        if (this.elements.radioSizeInputs.length && this.elements.addButton && this.elements.addButtonText && isChecked == false) {
          this.elements.addButton.disabled = true;
          this.elements.addButtonText.textContent = window.variantStrings.selectSize;
        }
      }
    },
  );
}
class State {
  constructor(bundleElmt) {
    if (State.instance) {
      return State.instance;
    }
    this.initProperties(bundleElmt);
    this.initRewards();
    this.initBundleSize();
    this.updateDiscount();
    this.updateTotalPrice();
    State.instance = this;
  }
  initProperties(bundleElmt) {
    this.observers = [];
    this.bundleElmt = bundleElmt;
    this.minimumBundleSize = parseInt(bundleElmt.getAttribute("min-products"));
    this.maximumBundleSize = parseInt(bundleElmt.getAttribute("max-products"));
    this.rewardType = bundleElmt.getAttribute("reward-type");
    this.momId = bundleElmt.getAttribute("momId");
    this.discount = 0;
    this.totalPrice = 0;
    this.totalDiscountPrice = 0;
    this.bundleSize = 0;
    this.storedProducts = JSON.parse(localStorage.getItem("bundleProducts")) || [];
  }
  initRewards() {
    this.raw_rewards = document.querySelector("[data-rewards]").innerHTML;
    this.reward_data = JSON.parse(this.raw_rewards);
    const rewardAttribute = this.rewardType == "product_quantity" ? "products_to_reach" : "amount_to_reach";
    this.rewardAttribute = rewardAttribute;
    this.rewardValueToCompareWith = this.rewardType == "product_quantity" ? "bundleSize" : "totalPrice";
    this.rewards = this.reward_data.rewards.sort((a, b) => a[rewardAttribute] - b[rewardAttribute]);
    this.products_to_reach = [0, ...this.rewards.map((r) => r[rewardAttribute]), 9999];
  }
  initBundleSize() {
    if (this.hasStoredProducts()) {
      this.bundleSize = this.storedProducts.reduce((acc2, curr) => {
        if (curr.gift_id) {
          return acc2;
        }
        acc2 += curr.quantity;
        return acc2;
      }, 0);
    }
  }
  updateTotalPrice() {
    this.totalPrice = this.storedProducts.reduce((total, product) => {
      if (product.hasOwnProperty("price") && !product.gift_id) {
        return total + Number(product.price * product.quantity);
      }
      return total;
    }, 0);
    this.totalDiscountPrice = this._calculateDiscountedPrice(this.totalPrice);
  }
  _calculateDiscountedPrice(totalPrice) {
    return totalPrice - (this.discount / 100) * totalPrice;
  }
  addObserver(observer) {
    this.observers.push(observer);
  }
  notifyObservers({ type, payload }) {
    for (const observer of this.observers) {
      observer.update({ type, payload });
    }
  }
  hasStoredProducts() {
    return this.storedProducts && this.storedProducts.length > 0;
  }
  setStoredProducts(storedProducts) {
    this.storedProducts = storedProducts;
    localStorage.setItem("bundleProducts", JSON.stringify(storedProducts));
  }
  addProduct(product) {
    const { variantId, gift_id } = product;
    if (!gift_id) {
      this.bundleSize++;
    }
    const productIndex = this.findProductIndexByVariantId(variantId);
    if (productIndex !== -1) {
      this.incrementProductQuantity(productIndex);
    } else {
      this.addNewProduct(product);
    }
    if (!gift_id) {
      this.updateDiscount();
      this.updateTotalPrice();
      this.updateGifts();
    }
    this.notifyObservers({
      type: "added_product",
      payload: { isGift: Boolean(gift_id) },
    });
  }
  removeProduct(variantId, isGift) {
    if (!isGift) {
      this.bundleSize--;
    }
    const productIndex = this.findProductIndexByVariantId(variantId);
    if (productIndex === -1) return;
    this.storedProducts[productIndex].quantity > 1 ? this.storedProducts[productIndex].quantity-- : this.storedProducts.splice(productIndex, 1);
    this.setStoredProducts(this.storedProducts);
    this.updateDiscount();
    this.updateTotalPrice();
    this.updateGifts();
    this.notifyObservers({ type: "removed_product", payload: { isGift } });
  }
  updateDiscount() {
    const discountReward = [...this.rewards].reverse().find((r) => this.isRewardMatching(r) && r.reward_type === "discount");
    if (discountReward) {
      this.discount = discountReward.discount_percentage;
    }
  }
  updateGifts() {
    this.rewards
      .filter((reward) => reward.reward_type === "gift_product")
      .forEach((reward, k) => {
        const relatedProduct = this.storedProducts.find((p) => p.gift_id === `gift_${k}`);
        const shouldAddGift = !relatedProduct && this.isRewardMatching(reward);
        const shouldRemoveGift = relatedProduct && !this.isRewardMatching(reward);
        if (shouldAddGift) {
          this.notifyObservers({
            type: "showGiftPopup",
            payload: {
              giftData: {
                gift_id: `gift_${k}`,
                ...this.reward_data.products[reward.discount_gift],
              },
            },
          });
        } else if (shouldRemoveGift) {
          this.removeProduct(relatedProduct.variantId, true);
        }
      });
  }
  //
  // Helper methods
  //
  isRewardMatching(reward) {
    return reward[this.rewardAttribute] <= this[this.rewardValueToCompareWith];
  }
  isRewardMatchingWithValue(rewardValue) {
    return rewardValue <= this[this.rewardValueToCompareWith];
  }
  findProductIndexByVariantId(variantId) {
    return this.storedProducts.findIndex((storedProduct) => storedProduct.variantId === variantId);
  }
  incrementProductQuantity(index) {
    this.storedProducts[index].quantity++;
    this.setStoredProducts([...this.storedProducts]);
  }
  addNewProduct(product) {
    const newProduct = { quantity: 1, ...product };
    this.setStoredProducts([...this.storedProducts, newProduct]);
  }
}
class UI {
  constructor(state, bundleElmt, elements, controller) {
    this.state = state;
    this.bundleElmt = bundleElmt;
    this.elements = elements;
    this.state.addObserver(this);
  }
  update({ type, payload }) {
    if (type == "showGiftPopup") {
      const { giftData } = payload;
      this.showBundleModal(giftData);
      return;
    }
    this.updateUI();
  }
  updateUI() {
    this.updateProductCounts();
    this.updateList();
    this.updateBar();
    this.updateBtn();
  }
  updateBar() {
    const progressBarWidth = this.calculateProgressBarWidth();
    this.elements.progressBarTrack.style.width = progressBarWidth;
    this.elements.progressBarReward.forEach((reward) => {
      const rewardVal = reward.getAttribute("jolly-data-reward");
      reward.classList.toggle("active", this.state.isRewardMatchingWithValue(rewardVal));
    });
    this.elements.bundleList.classList.toggle("tr-hidden", !this.state.hasStoredProducts());
  }
  calculateProgressBarWidth() {
    if (!this.state.hasStoredProducts()) return "0%";
    const goals = this.state.rewards.map((g) => g[this.state.rewardAttribute]);
    const rewardValueToCompareWith = this.state[this.state.rewardValueToCompareWith];
    for (let i = 0; i < goals.length; i++) {
      const [previousGoal, goal, nextGoal] = [goals[i - 1] || 0, goals[i], goals[i + 1]];
      if (rewardValueToCompareWith >= previousGoal && rewardValueToCompareWith < goal) {
        const segmentSize = 100 / goals.length;
        const segmentProgress = ((rewardValueToCompareWith - previousGoal) / (goal - previousGoal)) * segmentSize;
        return `${(i / goals.length) * 100 + segmentProgress}%`;
      } else if (rewardValueToCompareWith >= goal && !nextGoal) {
        return "100%";
      }
    }
    return "0%";
  }
  updateProductCounts() {
    this.elements.totalItems.innerHTML = this.state.bundleSize;
    document.querySelectorAll(`[counter-id]`).forEach((element) => {
      element.textContent = "";
      element.classList.add("!tr-hidden");
    });
    this.state.storedProducts.forEach((variant) => {
      let elements = document.querySelectorAll(`[counter-id="${variant.productId}"]`);
      for (let element of elements) {
        element.textContent = variant.quantity;
        element.classList.remove("!tr-hidden");
      }
    });
  }
  updateList() {
    const bundlePlaceholders = this.bundleElmt.querySelectorAll(".tr-bundle-placeholder");
    const bundle = document.getElementById("bundle-item");
    let element_html;
    const variantCounts = this.state.storedProducts.reduce((acc2, product, index) => {
      const existingProductIndex = acc2.findIndex((item) => item.variantId === product.variantId);
      if (existingProductIndex >= 0) {
        acc2[existingProductIndex].quantity += 1;
        if (index === this.state.storedProducts.length - 1 && index === this.state.maximumBundleSize - 1) {
          acc2[existingProductIndex].quantity -= 1;
          acc2.push({
            ...product,
            quantity: product.quantity,
            lastItem: true,
          });
        }
      } else {
        acc2.push({
          ...product,
          quantity: product.quantity,
          lastItem: false,
        });
      }
      return acc2;
    }, []);
    bundlePlaceholders.forEach((elem) => {
      elem.innerHTML = "";
    });
    variantCounts.forEach((product, i) => {
      var _a;
      if (bundlePlaceholders[i] != void 0) {
        let counter = "";
        counter = variantCounts[i].quantity;
        element_html = bundle.innerHTML
          .replaceAll("[product-title]", product.title)
          .replaceAll("[product-image]", product.image)
          .replaceAll("[product-size]", product.size)
          .replaceAll("[product-id]", product.productId)
          .replaceAll("[variant-id]", product.variantId)
          .replaceAll("[product-color]", product.color)
          .replaceAll("[product-count]", counter);
        bundlePlaceholders[i].innerHTML = element_html;
        this._toggleVisibilityBasedOnAttribute(product.color, ".bundle-card__color", bundlePlaceholders[i]);
        this._toggleVisibilityBasedOnAttribute(product.size, ".bundle-card__size", bundlePlaceholders[i]);
      } else if (bundlePlaceholders[i]) {
        (_a = bundlePlaceholders[i].querySelector(".bundle-card")) == null ? void 0 : _a.classList.add("tr-opacity-0");
      }
      if (product.gift_id) {
        let variantId = product.variantId;
        let jollyBundleItem = document.querySelector(`[jolly-bundle-item-id="${variantId}"]`);
        jollyBundleItem.classList.add("is-offer");
      }
    });
  }
  _toggleVisibilityBasedOnAttribute(attribute, selector, bundlePlaceholder) {
    const element = bundlePlaceholder.querySelector(selector);
    element.classList.toggle("tr-hidden", !attribute);
  }
  updateBtn() {
    if (this.state.hasStoredProducts() && this.state.bundleSize >= this.state.minimumBundleSize) {
      this.updateButtonForValidBundle();
    } else {
      this.updateButtonForIncompleteBundle();
    }
  }
  updateButtonForValidBundle() {
    const totalP = this.state.totalPrice;
    const totalWithDiscount = this.state.totalDiscountPrice;
    this.elements.addToCartButtons.forEach((button) => {
      button.querySelector(".btn-content").innerHTML = this._getButtonContentForValidBundle(totalWithDiscount, totalP);
      button.disabled = false;
      button.classList.remove("btn-secondary");
    });
  }
  updateButtonForIncompleteBundle() {
    const remainingProductsToAdd = this.state.minimumBundleSize - this.state.bundleSize;
    this.elements.addToCartButtons.forEach((button) => {
      const buttonText = button.querySelector(".btn-content");
      if (window.innerWidth <= 992) {
        buttonText.innerHTML = window.bundle.addToBundleMobile.replace("{{products_to_add}}", remainingProductsToAdd).replace("{{s}}", remainingProductsToAdd > 1 ? "s" : "");
      } else {
        buttonText.innerHTML = window.bundle.addToBundle.replace("{{products_to_add}}", remainingProductsToAdd).replace("{{s}}", remainingProductsToAdd > 1 ? "s" : "");
      }
      button.classList.add("btn-secondary");
      button.disabled = true;
    });
  }
  showBundleModal(giftData) {
    var _a, _b;
    (_a = document.querySelector("jolly-modal")) == null ? void 0 : _a.setContent(".popup-offer");
    (_b = document.querySelector("jolly-modal")) == null ? void 0 : _b.show();
    const modalSizeSelectors = document.querySelectorAll('jolly-modal [name*="TAILLE"]');
    modalSizeSelectors.forEach((modalSizeSelector) => {
      this.bundleElmt.setChangeListener(modalSizeSelector);
    });
    document.querySelectorAll("jolly-modal .tr-bundle-item-add").forEach((el) => {
      el.addEventListener("click", (ev) => {
        var _a2;
        (_a2 = document.querySelector("jolly-modal")) == null ? void 0 : _a2.hide();
        this.bundleElmt.onAddToBundleClick(el, giftData);
      });
    });
  }
  _getButtonContentForValidBundle(totalWithDiscount, totalP) {
    return `${window.bundle.addToCartBtn} • ${totalWithDiscount.toFixed(2)}€ <s class="tr-opacity-50">${totalP.toFixed(2)}</s>`;
  }
  setCartErrorMsg(msg) {
    const errorMsgElmt = this.bundleElmt.querySelector(".atc-error-msg");
    if (!msg) {
      errorMsgElmt.classList.add("tr-hidden");
    }
    errorMsgElmt.innerText = msg;
  }
  // ... other UI update methods ...
}
if (!customElements.get("jolly-bundle-maker")) {
  customElements.define(
    "jolly-bundle-maker",
    class JollyBundleMaker extends HTMLElement {
      constructor() {
        super();
        this.state = new State(this);
        this.elements = {
          bundleList: this.querySelector(".bundle-list"),
          collectionList: this.querySelector(".collection-list"),
          progressBar: this.querySelector(".tr-progress-bar"),
          progressBarTrack: this.querySelector(".tr-progress-bar-track"),
          progressBarReward: this.querySelectorAll("[jolly-data-reward]"),
          addToCartButtons: this.querySelectorAll(".add-to-cart-button"),
          removeFromBundleButton: this.querySelector(".tr-bundle-item-remove"),
          totalItems: this.querySelector(".jolly-total-items"),
        };
        this.ui = new UI(this.state, this, this.elements);
        this.ui.updateUI();
        this.elements.addToCartButtons.forEach((button) => {
          button.addEventListener("click", () => this.onAddToCartClick());
        });
        this.querySelectorAll('[name*="TAILLE"]').forEach((element) => {
          this.setChangeListener(element);
        });
        this.querySelectorAll('[name*="COULEUR"]').forEach((element) => {
          element.addEventListener("click", () => {
            element
              .closest("jolly-product-card")
              .querySelectorAll('[name*="TAILLE"]:checked')
              .forEach((input) => {
                input.checked = false;
              });
            element.closest("jolly-product-card").querySelector(".tr-bundle-item-add").classList.remove("active");
          });
        });
        document.addEventListener("click", (event) => {
          const clickedElement = event.target;
          if (clickedElement.closest(".tr-bundle-item-remove")) {
            const variantId = clickedElement.closest(".tr-bundle-item-remove").dataset.variantId;
            this.state.removeProduct(variantId);
            clickedElement.closest(".tr-bundle-item-remove").dataset.variantId = "";
          }
          if (clickedElement.closest(".tr-bundle-item-add") && !clickedElement.closest(".modal-content")) {
            this.onAddToBundleClick(clickedElement);
            let jollyModalProduct = document.querySelector("jolly-modal-product");
            jollyModalProduct.classList.remove("tr-translate-y-0");
            jollyModalProduct.classList.add("tr-translate-y-full");
            //document.getElementById("tr-modal-shadow").classList.add("tr-hidden");
          }
        });
      }
      setChangeListener(element) {
        element.addEventListener("change", () => {
          if (!element.classList.contains("disabled")) {
            element.closest("jolly-product-card").querySelector(".tr-bundle-item-add").classList.add("active");
          } else {
            element.closest("jolly-product-card").querySelector(".tr-bundle-item-add").classList.remove("active");
          }
        });
      }
      onAddToCartClick() {
        this.elements.addToCartButtons.forEach((btn) => btn.classList.add("loading"));
        let discount = this.state.discount;
        let bundleId = new Date().valueOf();
        let items = [];
        for (let i = 0; i < this.state.storedProducts.length; i++) {
          const currentProduct = this.state.storedProducts[i];
          let newItem = {
            id: currentProduct.variantId,
            quantity: currentProduct.quantity,
            properties: {
              _mainBundleId: bundleId,
              _isBundleGift: false,
              _isMomBundle: false,
              _bundleDiscount: discount,
            },
          };
          items.push(newItem);
        }
        const momElement = {
          id: this.state.momId,
          quantity: 1,
          properties: {
            _mainBundleId: bundleId,
            _isBundleGift: false,
            _isMomBundle: true,
            _bundleDiscount: discount,
          },
        };
        items.push(momElement);
        let data = {
          items,
          sections: ["cart-drawer", "cart-icon-bubble"],
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then(async (response) => {
            let json = await response.json();
            this.elements.addToCartButtons.forEach((btn) => btn.classList.remove("loading"));
            if (json.status > 200) {
              this.ui.setCartErrorMsg(json.description);
              return;
            }
            document.querySelector("cart-drawer").renderContents(json);
            document.querySelector("cart-drawer").classList.remove("is-empty");
            this.state.bundleSize = 0;
            this.state.setStoredProducts([]);
            this.ui.updateUI();
          })
          .catch((e) => console.error("Error adding to cart:", e));
      }
      onAddToBundleClick(el, giftData = {}) {
        var _a;
        const product = el.closest("jolly-product-card");
        if (!product) {
          return;
        }
        if (this.state.storedProducts && this.state.bundleSize == this.state.maximumBundleSize) {
          return;
        }
        const productId = product.querySelector("form").getAttribute("id");
        const variantId = product.querySelector('[name="id"]').value;
        const title = product.querySelector('[name="title"]').value;
        const variantInventoryStock = product.querySelector(".product-variant-quantity").value;
        let image = product.querySelector('[name="image"]').value;
        const size = (_a = product.querySelector('input[name*="TAILLE"]:checked')) == null ? void 0 : _a.value;
        const price = product.querySelector(".money").innerHTML.replace("€", "").replace(",", ".");
        let color = "";
        const colorInput = product == null ? void 0 : product.querySelector('input[name*="COULEUR"]:checked');
        if (colorInput !== null) {
          color = colorInput.dataset.color;
          let colorValue = colorInput.dataset.bundleColor;
          image = product.querySelector('[jolly-img="' + colorValue + '"]').getAttribute("src");
        }
        let variantSelectedQuantity = 0;
        if (this.state.hasStoredProducts()) {
          const product2 = this.state.storedProducts.find((storedProduct) => {
            return storedProduct.variantId == variantId;
          });
          if (product2) {
            variantSelectedQuantity += product2;
          }
        }
        if (variantSelectedQuantity > variantInventoryStock) {
          product.querySelector(".tr-bundle-item-error").classList.remove("tr-hidden");
          setTimeout(() => {
            product.querySelector(".tr-bundle-item-error").classList.add("tr-hidden");
          }, 2500);
          return;
        }
        this.state.addProduct({
          productId,
          variantId,
          title,
          image,
          size,
          color,
          price,
          ...giftData,
          // does nothing if gift data was not sent
        });
      }
    },
  );
}
class JollyModal extends HTMLElement {
  constructor() {
    super();
    if (this.querySelector("#closeModalBtn")) {
      this.querySelector("#closeModalBtn").addEventListener("click", () => {
        this.hide();
      });
    }
    if (this.querySelector(".overlay")) {
      this.querySelector(".overlay").addEventListener("click", () => {
        this.hide();
      });
    }
  }
  setContent(selector) {
    const contentElement = document.querySelector(selector);
    if (contentElement) {
      const dynamicContent = this.querySelector("#dynamicContent");
      dynamicContent.innerHTML = contentElement.innerHTML;
    }
  }
  show() {
    this.classList.add("modal-show");
  }
  hide() {
    this.classList.remove("modal-show");
  }
}
customElements.define("jolly-modal", JollyModal);
function classesToSelector(classes = "") {
  return `.${classes
    .trim()
    .replace(/([\.:!\/])/g, "\\$1")
    .replace(/ /g, ".")}`;
}

function Pagination({ swiper, extendParams, on, emit }) {
  const pfx = "swiper-pagination";
  extendParams({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: (number) => number,
      formatFractionTotal: (number) => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`,
    },
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: [],
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }
  function setSideBullets($bulletEl, position) {
    const { bulletActiveClass } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }
  function update() {
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }
      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
    } else if (typeof swiper.snapIndex !== "undefined") {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    }
    if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
        $el.css(swiper.isHorizontal() ? "width" : "height", `${bulletSize * (params.dynamicMainBullets + 4)}px`);
        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== void 0) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((suffix) => `${params.bulletActiveClass}${suffix}`).join(" "));
      if ($el.length > 1) {
        bullets.each((bullet) => {
          const $bullet = $(bullet);
          const bulletIndex = $bullet.index();
          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }
            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, "prev");
            }
            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, "next");
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);
        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }
          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }
              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              setSideBullets($firstDisplayedBullet, "prev");
              setSideBullets($lastDisplayedBullet, "next");
            }
          } else {
            setSideBullets($firstDisplayedBullet, "prev");
            setSideBullets($lastDisplayedBullet, "next");
          }
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? "right" : "left";
        bullets.css(swiper.isHorizontal() ? offsetProp : "top", `${bulletsOffset}px`);
      }
    }
    if (params.type === "fraction") {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }
    if (params.type === "progressbar") {
      let progressbarDirection;
      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
      } else {
        progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
      }
      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;
      if (progressbarDirection === "horizontal") {
        scaleX = scale;
      } else {
        scaleY = scale;
      }
      $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }
    if (params.type === "custom" && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit("paginationRender", $el[0]);
    } else {
      emit("paginationUpdate", $el[0]);
    }
    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    }
  }
  function render() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let paginationHTML = "";
    if (params.type === "bullets") {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }
    if (params.type === "fraction") {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span> / <span class="${params.totalClass}"></span>`;
      }
      $el.html(paginationHTML);
    }
    if (params.type === "progressbar") {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
      $el.html(paginationHTML);
    }
    if (params.type !== "custom") {
      emit("paginationRender", swiper.pagination.$el[0]);
    }
  }
  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: "swiper-pagination",
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let $el = $(params.el);
    if ($el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
      $el = swiper.$el.find(params.el);
      if ($el.length > 1) {
        $el = $el.filter((el) => {
          if ($(el).parents(".swiper")[0] !== swiper.el) return false;
          return true;
        });
      }
    }
    if (params.type === "bullets" && params.clickable) {
      $el.addClass(params.clickableClass);
    }
    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (params.type === "bullets" && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      dynamicBulletIndex = 0;
      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }
    if (params.type === "progressbar" && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }
    if (params.clickable) {
      $el.on("click", classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        let index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }
    Object.assign(swiper.pagination, {
      $el,
      el: $el[0],
    });
    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
    if (params.clickable) {
      $el.off("click", classesToSelector(params.bulletClass));
    }
  }
  on("init", () => {
    if (swiper.params.pagination.enabled === false) {
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on("activeIndexChange", () => {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === "undefined") {
      update();
    }
  });
  on("snapIndexChange", () => {
    if (!swiper.params.loop) {
      update();
    }
  });
  on("slidesLengthChange", () => {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on("snapGridLengthChange", () => {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on("destroy", () => {
    destroy();
  });
  on("enable disable", () => {
    const { $el } = swiper.pagination;
    if ($el) {
      $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
    }
  });
  on("lock unlock", () => {
    update();
  });
  on("click", (_s, e) => {
    const targetEl = e.target;
    const { $el } = swiper.pagination;
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && ((swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) || (swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl))) return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit("paginationShow");
      } else {
        emit("paginationHide");
      }
      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });
  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }
    init();
    render();
    update();
  };
  const disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy,
  });
}
function Controller({ swiper, extendParams, on }) {
  extendParams({
    controller: {
      control: void 0,
      inverse: false,
      by: "slide",
      // or 'container'
    },
  });
  swiper.controller = {
    control: void 0,
  };
  function LinearSpline(x, y) {
    const binarySearch = (function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = (maxIndex + minIndex) >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    })();
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    let i1;
    let i3;
    this.interpolate = function interpolate(x2) {
      if (!x2) return 0;
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;
      return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };
    return this;
  }
  function getInterpolateFunction(c) {
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  }
  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper2 = swiper.constructor;
    function setControlledTranslate(c) {
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === "slide") {
        getInterpolateFunction(c);
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }
      if (!controlledTranslate || swiper.params.controller.by === "container") {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }
      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper2) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper2 && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }
  function setTransition(duration, byController) {
    const Swiper2 = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;
    function setControlledTransition(c) {
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }
        c.$wrapperEl.transitionEnd(() => {
          if (!controlled) return;
          if (c.params.loop && swiper.params.controller.by === "slide") {
            c.loopFix();
          }
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper2) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper2 && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
  function removeSpline() {
    if (!swiper.controller.control) return;
    if (swiper.controller.spline) {
      swiper.controller.spline = void 0;
      delete swiper.controller.spline;
    }
  }
  on("beforeInit", () => {
    swiper.controller.control = swiper.params.controller.control;
  });
  on("update", () => {
    removeSpline();
  });
  on("resize", () => {
    removeSpline();
  });
  on("observerUpdate", () => {
    removeSpline();
  });
  on("setTranslate", (_s, translate, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on("setTransition", (_s, duration, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition,
  });
}
function Autoplay({ swiper, extendParams, on, emit }) {
  let timeout;
  swiper.autoplay = {
    running: false,
    paused: false,
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3e3,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false,
    },
  });
  function run() {
    if (!swiper.size) {
      swiper.autoplay.running = false;
      swiper.autoplay.paused = false;
      return;
    }
    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;
    if ($activeSlideEl.attr("data-swiper-autoplay")) {
      delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
    }
    clearTimeout(timeout);
    timeout = nextTick(() => {
      let autoplayResult;
      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit("autoplay");
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit("autoplay");
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit("autoplay");
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit("autoplay");
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit("autoplay");
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit("autoplay");
      } else {
        stop();
      }
      if (swiper.params.cssMode && swiper.autoplay.running) run();
      else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }
  function start() {
    if (typeof timeout !== "undefined") return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    emit("autoplayStart");
    run();
    return true;
  }
  function stop() {
    if (!swiper.autoplay.running) return false;
    if (typeof timeout === "undefined") return false;
    if (timeout) {
      clearTimeout(timeout);
      timeout = void 0;
    }
    swiper.autoplay.running = false;
    emit("autoplayStop");
    return true;
  }
  function pause(speed) {
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (timeout) clearTimeout(timeout);
    swiper.autoplay.paused = true;
    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ["transitionend", "webkitTransitionEnd"].forEach((event) => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }
  function onVisibilityChange() {
    const document2 = getDocument();
    if (document2.visibilityState === "hidden" && swiper.autoplay.running) {
      pause();
    }
    if (document2.visibilityState === "visible" && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }
  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ["transitionend", "webkitTransitionEnd"].forEach((event) => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;
    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }
  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      emit("autoplayPause");
      pause();
    }
    ["transitionend", "webkitTransitionEnd"].forEach((event) => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }
  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }
    swiper.autoplay.paused = false;
    emit("autoplayResume");
    run();
  }
  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on("mouseenter", onMouseEnter);
      swiper.$el.on("mouseleave", onMouseLeave);
    }
  }
  function detachMouseEvents() {
    swiper.$el.off("mouseenter", onMouseEnter);
    swiper.$el.off("mouseleave", onMouseLeave);
  }
  on("init", () => {
    if (swiper.params.autoplay.enabled) {
      start();
      const document2 = getDocument();
      document2.addEventListener("visibilitychange", onVisibilityChange);
      attachMouseEvents();
    }
  });
  on("beforeTransitionStart", (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on("sliderFirstMove", () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on("touchEnd", () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on("destroy", () => {
    detachMouseEvents();
    if (swiper.autoplay.running) {
      stop();
    }
    const document2 = getDocument();
    document2.removeEventListener("visibilitychange", onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop,
  });
}
function Thumb({ swiper, extendParams, on }) {
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs",
    },
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null,
  };
  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
    let slideToIndex;
    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      let currentIndex = swiper.activeIndex;
      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix();
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }
      const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
      else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
      else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
      else slideToIndex = prevIndex;
    }
    swiper.slideTo(slideToIndex);
  }
  function init() {
    const { thumbs: thumbsParams } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false,
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false,
      });
    } else if (isObject(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false,
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }
    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on("tap", onThumbClick);
    return true;
  }
  function update(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }
    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }
    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);
    if (thumbsSwiper.params.loop || (thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled)) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
      }
    }
    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      let currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;
      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix();
          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        }
        const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
        const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
        if (typeof prevThumbsIndex === "undefined") {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === "undefined") {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }
        direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
      }
      if (useOffset) {
        newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
      }
      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1);
        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : void 0);
      }
    }
  }
  on("beforeInit", () => {
    const { thumbs } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    init();
    update(true);
  });
  on("slideChange update resize observerUpdate", () => {
    update();
  });
  on("setTransition", (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on("beforeDestroy", () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update,
  });
}
function effectInit(params) {
  const { effect, swiper, on, setTranslate, setTransition, overwriteParams, perspective, recreateShadows, getEffectParams } = params;
  on("beforeInit", () => {
    if (swiper.params.effect !== effect) return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }
    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on("setTranslate", () => {
    if (swiper.params.effect !== effect) return;
    setTranslate();
  });
  on("setTransition", (_s, duration) => {
    if (swiper.params.effect !== effect) return;
    setTransition(duration);
  });
  on("transitionEnd", () => {
    if (swiper.params.effect !== effect) return;
    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows) return;
      swiper.slides.each((slideEl) => {
        const $slideEl = swiper.$(slideEl);
        $slideEl.find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
      });
      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on("virtualUpdate", () => {
    if (swiper.params.effect !== effect) return;
    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }
    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate();
        requireUpdateOnVirtual = false;
      }
    });
  });
}
function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      "backface-visibility": "hidden",
      "-webkit-backface-visibility": "hidden",
    });
  }
  return $slideEl;
}

function effectVirtualTransitionEnd({ swiper, duration, transformEl, allSlides }) {
  const { slides, activeIndex, $wrapperEl } = swiper;
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let $transitionEndTarget;
    if (allSlides) {
      $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
    } else {
      $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
    }
    $transitionEndTarget.transitionEnd(() => {
      if (eventTriggered) return;
      if (!swiper || swiper.destroyed) return;
      eventTriggered = true;
      swiper.animating = false;
      const triggerEvents = ["webkitTransitionEnd", "transitionend"];
      for (let i = 0; i < triggerEvents.length; i += 1) {
        $wrapperEl.trigger(triggerEvents[i]);
      }
    });
  }
}

function EffectFade({ swiper, extendParams, on }) {
  extendParams({
    fadeEffect: {
      crossFade: false,
      transformEl: null,
    },
  });
  const setTranslate = () => {
    const { slides } = swiper;
    const params = swiper.params.fadeEffect;
    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = swiper.slides.eq(i);
      const offset = $slideEl[0].swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl
        .css({
          opacity: slideOpacity,
        })
        .transform(`translate3d(${tx}px, ${ty}px, 0px)`);
    }
  };
  const setTransition = (duration) => {
    const { transformEl } = swiper.params.fadeEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides: true,
    });
  };
  effectInit({
    effect: "fade",
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode,
    }),
  });
}
new Swiper("#announcementBarSwiper", {
  modules: [Autoplay, EffectFade],
  speed: 500,
  effect: "fade",
  autoplay: {
    delay: 3e3,
  },
  noSwiping: true,
  noSwipingClass: "swiper-slide",
});

new Swiper(".swiperReinsuranceProduct", {
  modules: [Autoplay, Pagination],
  slidesPerView: 1,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 3e3,
  },
  pagination: {
    el: "#swiperReinsuranceProduct .swiper-pagination",
    type: "bullets",
    clickable: true,
  },
});

const reinsuranceCartSlides = document.querySelectorAll("#swiperReinsuranceCart .swiper-slide");
const reinsuranceCartHasMultiple = reinsuranceCartSlides.length > 1;

new Swiper("#swiperReinsuranceCart", {
  modules: [Pagination, Autoplay],
  slidesPerView: "auto",
  loop: reinsuranceCartHasMultiple,
  autoplay: reinsuranceCartHasMultiple ? { delay: 3000 } : false,
  pagination: {
    el: "#swiperReinsuranceCart .swiper-pagination",
    type: "bullets",
    clickable: true,
  },
});

document.querySelectorAll(".tr-hero-slider").forEach((element) => {
  let swiperEl = document.querySelector("#" + element.id + " .swiper");

  // Vérifier que l'élément Swiper existe avant de continuer
  if (!swiperEl) {
    return;
  }

  // Compter le nombre de slides
  const slides = swiperEl.querySelectorAll(".swiper-slide");
  const hasMultipleSlides = slides.length > 1;

  // Construire la configuration selon le nombre de slides
  let swiperConfig;

  if (hasMultipleSlides) {
    // Configuration pour plusieurs slides
    swiperConfig = {
      modules: [Autoplay, Pagination, EffectFade],
      slidesPerView: 1,
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5e3,
      },
      pagination: {
        el: "#" + element.id + " .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      on: {
        init: function () {
          // Jouer la vidéo du slide initial
          const activeSlide = swiperEl.querySelector(".swiper-slide-active");
          if (activeSlide) {
            const video = activeSlide.querySelector("video");
            if (video) {
              // Attendre que la vidéo soit prête avant de la jouer
              if (video.readyState >= 2) {
                video.play().catch(() => {});
              } else {
                video.addEventListener(
                  "loadeddata",
                  () => {
                    video.play().catch(() => {});
                  },
                  { once: true },
                );
              }
            }
          }
        },
        slideChange: function () {
          // Utiliser un petit délai pour éviter les relances lors de scrolls horizontaux
          // qui ne changent pas vraiment de slide (problème avec loop: true)
          const swiperInstance = this;
          clearTimeout(swiperInstance._videoChangeTimeout);

          swiperInstance._videoChangeTimeout = setTimeout(() => {
            const activeSlide = swiperEl.querySelector(".swiper-slide-active");
            const activeVideo = activeSlide ? activeSlide.querySelector("video") : null;

            // Pauser toutes les vidéos sauf celle du slide actif
            const allVideos = swiperEl.querySelectorAll("video");
            allVideos.forEach((video) => {
              if (video !== activeVideo && !video.paused) {
                video.pause();
              }
            });

            // Jouer la vidéo du slide actif seulement si elle n'est pas déjà en cours
            if (activeVideo) {
              // Vérifier si la vidéo est vraiment en pause ou terminée
              // Ne pas relancer si elle est déjà en cours de lecture
              if (activeVideo.paused || activeVideo.ended) {
                // Ne remettre à zéro que si la vidéo est vraiment terminée
                if (activeVideo.ended) {
                  activeVideo.currentTime = 0;
                }
                activeVideo.play().catch(() => {});
              }
            }
          }, 150);
        },
        slideChangeTransitionStart: function () {
          // Pauser temporairement les vidéos pendant la transition pour éviter les conflits
          const allVideos = swiperEl.querySelectorAll("video");
          allVideos.forEach((video) => {
            if (!video.paused) {
              video.dataset.wasPlaying = "true";
              video.pause();
            }
          });
        },
      },
    };
  } else {
    // Configuration pour une seule slide (pas de modules, pas de loop, pas de fade)
    swiperConfig = {
      modules: [],
      slidesPerView: 1,
      loop: false,
      effect: "slide",
      on: {
        init: function () {
          // Jouer la vidéo du slide initial
          const activeSlide = swiperEl.querySelector(".swiper-slide-active");
          if (activeSlide) {
            const video = activeSlide.querySelector("video");
            if (video) {
              // Attendre que la vidéo soit prête avant de la jouer
              if (video.readyState >= 2) {
                video.play().catch(() => {});
              } else {
                video.addEventListener(
                  "loadeddata",
                  () => {
                    video.play().catch(() => {});
                  },
                  { once: true },
                );
              }
            }
          }
        },
      },
    };
  }

  // Initialiser Swiper avec la configuration
  new Swiper(swiperEl, swiperConfig);
});

function deliveryEstimate() {
  if (document.querySelector(".delivery-date-snippet")) {
    let deliverySnippet = document.querySelector(".delivery-date-snippet");
    const deliveryFill = document.querySelectorAll(".tr-delivery-fill-please");
    deliveryFill.forEach((el) => {
      el.innerHTML = deliverySnippet.innerHTML;
    });
  }
}
document.addEventListener("update-delivery-estimate", () => {
  deliveryEstimate();
});
function updateCart() {
  document.querySelectorAll(".tr-cart-swiper").forEach((element) => {
    let swiperEl = document.querySelector("#" + element.id + ".swiper");
    new Swiper(swiperEl, {
      modules: [Autoplay, Pagination],
      slidesPerView: 1.7,
      spaceBetween: 20,
      breakpoints: {
        500: {
          slidesPerView: 2,
        },
      },
      autoHeight: true,
      noSwiping: false,
      noSwipingSelector: ".variants-swiper",
      pagination: {
        el: "#" + element.id + " .tr-cart-swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  });

  //deliveryEstimate();

  document.querySelectorAll(".variants-swiper").forEach((elmt) => {
    let swiperEl = elmt.querySelector("#" + elmt.id + " .swiper");
    if (!swiperEl) return;
    new Swiper(swiperEl, {
      modules: [Navigation],
      slidesPerView: "auto",
      spaceBetween: 6,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: swiperEl.nextElementSibling,
        prevEl: swiperEl.nextElementSibling.nextElementSibling,
      },
    });
  });

  document.querySelectorAll(".variants-swiper.variants-swiper-color").forEach((elmt) => {
    let swiperEl = elmt.querySelector("#" + elmt.id + " .swiper");
    if (!swiperEl) return;
    new Swiper(swiperEl, {
      modules: [Navigation],
      slidesPerView: 2,
      spaceBetween: 0,
      noSwiping: false,
      slideToClickedSlide: false,
      navigation: {
        nextEl: swiperEl.nextElementSibling,
        prevEl: swiperEl.nextElementSibling.nextElementSibling,
      },
    });
  });

  document.querySelectorAll(".tr-cart-offer-swiper").forEach((element) => {
    let swiperEl = document.querySelector("#cart-offer-swiper");
    new Swiper(swiperEl, {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 25,
      autoHeight: false,
      pagination: {
        el: "#" + element.id + " .tr-cart-offer-swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      watchOverflow: false,
    });
  });

  document.querySelectorAll("cart-gift-carousel").forEach((element) => {
    const swiperEl = element.querySelector("#swiperCartGiftCarousel");
    if (!swiperEl) return;
    if (swiperEl.swiperInstance) {
      try { swiperEl.swiperInstance.destroy(true, true); } catch (e) {}
    }
    const slides = swiperEl.querySelectorAll(".swiper-slide");
    const hasMultiple = slides.length > 1;
    const delay = parseInt(element.dataset.autoplayDelay, 10) || 3000;
    swiperEl.swiperInstance = new Swiper(swiperEl, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      loop: hasMultiple,
      autoplay: hasMultiple ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
      pagination: {
        el: swiperEl.querySelector(".cart-gift-carousel__pagination"),
        type: "bullets",
        clickable: true,
      },
    });
  });
}
updateCart();
document.addEventListener("tr-cart:reload", (ev) => {
  updateCart();
});
document.querySelectorAll(".tr-retailers-swiper").forEach((el) => {
  new Swiper(el, {
    modules: [EffectFade, Pagination],
    autoplay: true,
    slidesPerView: "auto",
    effect: "fade",
    // If we need pagination
    pagination: {
      el: `#${el.id}.swiper-pagination`,
    },
    loop: true,
  });
});
document.querySelectorAll(".tr-sizes-swiper").forEach((elmt) => {
  let swiperEl = document.querySelector("#" + elmt.id + " .swiper");
  new Swiper(swiperEl, {
    modules: [Navigation],
    slidesPerView: "auto",
    loop: true,
    threshold: 10,
    slideToClickedSlide: false,
    navigation: {
      prevEl: "#" + elmt.id + " .tr-swiper-prev",
      nextEl: "#" + elmt.id + " .tr-swiper-next",
    },
  });
});
document.querySelectorAll(".tr-products-collection").forEach((elmt) => {
  new Swiper("#" + elmt.id, {
    modules: [Navigation, Mousewheel],
    slidesPerView: "auto",
    direction: "horizontal",
    touch: true,
    mousewheel: {
      forceToAxis: true,
    },
  });
});
document.querySelectorAll(".tr-video-testimonials").forEach((elmt) => {
  new Swiper("#" + elmt.id, {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 16,
    mousewheel: false,
    navigation: {
      prevEl: "#" + elmt.id + " .swiper-button-prev",
      nextEl: "#" + elmt.id + " .swiper-button-next",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
      },
    },
  });
});
const reviewsSlider = document.querySelectorAll(".tr-review-testimonial-swiper");
const reviewsGalleryThumbs = document.querySelectorAll(".tr-review-testimonial-swiper-thumbs");
for (let i = 0; i < reviewsSlider.length; i++) {
  const reviewsGalThumbs = new Swiper("#" + reviewsGalleryThumbs[i].id, {
    modules: [Controller],
    slidesPerView: "auto",
    spaceBetween: 24,
    initialSlide: 1,
    centeredSlides: true,
    slideToClickedSlide: true,
  });
  const reviewsGal = new Swiper("#" + reviewsSlider[i].id, {
    modules: [Thumb, Controller, EffectFade],
    noSwiping: true,
    effect: "fade",
    speed: 300,
    initialSlide: 1,
    noSwipingClass: "swiper-slide",
  });
  reviewsGalThumbs.controller.control = reviewsGal;
  reviewsGal.controller.control = reviewsGalThumbs;
}
const videos = document.querySelectorAll("video");
const buttonsPlay = document.querySelectorAll(".tr-video-play");
buttonsPlay.forEach((button) => {
  button.addEventListener("click", () => {
    const curVideo = document.getElementById(button.dataset.id);
    if (!button.classList.contains("is-play")) {
      for (let i = 0; i < videos.length; i++) {
        if (videos[i] !== curVideo && !videos[i].paused) {
          videos[i].pause();
        }
      }
      buttonsPlay.forEach((btn) => {
        btn.classList.remove("is-play");
      });
      button.classList.add("is-play");
      curVideo.play();
    } else {
      button.classList.remove("is-play");
      curVideo.pause();
    }
  });
});
const acc = document.querySelectorAll(".tr-accordion-title");
acc.forEach((item) => {
  item.addEventListener("click", (e) => {
    const btn = e.target.closest(".tr-accordion-title");
    const paper = btn.closest(".tr-accordion");
    const content = paper.querySelector(".tr-accordion-content");
    const isOpening = content.style.maxHeight === "0px" || content.style.maxHeight === "";
    btn.classList.toggle("active", isOpening);
    if (isOpening) {
      content.style.maxHeight = content.scrollHeight + "px";
      btn.setAttribute("aria-expanded", "true");
    } else {
      content.style.maxHeight = "0px";
      btn.setAttribute("aria-expanded", "false");
    }
  });
});

// Ca cause un soucis sur Safari/firefox ce truc, et ca sert à rien
// window.addEventListener("mousemove", accordionMove);
// window.addEventListener("scroll", accordionMove);
// window.addEventListener("resize", accordionMove);
// function accordionMove() {
//   document.querySelectorAll(".tr-accordion-content").forEach((item) => {
//     console.log(item.scrollHeight);
//     if (item.style.maxHeight != "0px") {
//       item.style.maxHeight = item.scrollHeight + "px";
//     }
//   });
// }

document.querySelectorAll(".tr-bundle-list").forEach((slider) => {
  let swiperEl = document.querySelector("#" + slider.id);
  new Swiper(swiperEl, {
    modules: [Navigation, Pagination, Scrollbar, Mousewheel],
    slidesPerView: "auto",
    spaceBetween: 25,
    threshold: 10,
    direction: "horizontal",
    touch: true,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: document.querySelector("#" + slider.id + "-scroll"),
      draggable: true,
    },
  });
});
const firstCategoryElement = document.querySelector("[jolly-data-category]");
if (firstCategoryElement) {
  const categoryValue = firstCategoryElement.getAttribute("jolly-data-category");
  const swiperSlides = document.querySelectorAll("[jolly-data-filter]");
  firstCategoryElement.classList.add("active");
  swiperSlides.forEach((slide) => {
    const filterValue = slide.getAttribute("jolly-data-filter");
    if (filterValue !== categoryValue) {
      slide.classList.remove("swiper-slide");
      slide.classList.add("not-swiper-slide");
    }
  });
}
const trProductsListEl = document.querySelector(".tr-products-list");
if (trProductsListEl) {
  const trProductsListScrollbarEl = trProductsListEl.querySelector(".jc-products-list-scrollbar");
  const collectionSwiper = new Swiper(trProductsListEl, {
    modules: [Navigation, Pagination, Scrollbar, Mousewheel],
    slidesPerView: 1.1,
    spaceBetween: 10,
    threshold: 10,
    direction: "horizontal",
    touch: true,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: trProductsListScrollbarEl
      ? {
          el: trProductsListScrollbarEl,
          draggable: true,
        }
      : undefined,
    breakpoints: {
      992: {
        slidesPerView: 4.3,
        spaceBetween: 10,
      },
      1600: {
        slidesPerView: 4.3,
      },
    },
  });
  collectionSwiper.update();

  const buttonsEl = document.querySelector(".tr-products-list-buttons");
  if (buttonsEl) {
    const collectionButtonsSwiper = new Swiper(buttonsEl, {
      modules: [Navigation, Scrollbar, Mousewheel],
      slidesPerView: "auto",
      spaceBetween: 0,
      threshold: 10,
      direction: "horizontal",
      touch: true,
      mousewheel: {
        forceToAxis: true,
      },
    });
    collectionButtonsSwiper.on("click", function (swiper) {
      swiper.slideTo(swiper.clickedIndex);
      collectionSwiper.slideTo(0);
    });
  }

  const categoryElements = document.querySelectorAll("[jolly-data-category]");
  const categoryLinks = document.querySelectorAll(".products-list-link");
  categoryElements.forEach(function (element) {
    element.addEventListener("click", function () {
      const categoryValue = this.getAttribute("jolly-data-category");
      const catLink = this.getAttribute("jolly-data-url");
      const swiperSlides = document.querySelectorAll("[jolly-data-filter]");
      categoryElements.forEach((btn) => btn.classList.remove("active"));
      categoryLinks.forEach((link) => link.setAttribute("href", catLink));
      this.classList.add("active");
      swiperSlides.forEach(function (slide) {
        const filterValue = slide.getAttribute("jolly-data-filter");
        if (filterValue === categoryValue) {
          slide.classList.remove("not-swiper-slide");
          slide.classList.add("swiper-slide");
        } else {
          slide.classList.remove("swiper-slide");
          slide.classList.add("not-swiper-slide");
        }
      });
      collectionSwiper.update();
    });
  });
}
document.querySelectorAll(".tr-testimonials").forEach((slider) => {
  new Swiper("#" + slider.id, {
    modules: [Navigation, Pagination, Scrollbar, Mousewheel],
    slidesPerView: "auto",
    spaceBetween: 25,
    direction: "horizontal",
    touch: true,
    mousewheel: {
      forceToAxis: true,
    },
    threshold: 10,
    scrollbar: {
      el: document.querySelector("#" + slider.id + "-scroll"),
      draggable: true,
    },
  });
});
let swipers = [];
function initSwipers() {
  const swiperElements = document.querySelectorAll(".tr-bundle-v2");
  swiperElements.forEach(function (element) {
    const swiper = new Swiper(element, {
      modules: [Navigation, Pagination, Scrollbar, Mousewheel],
      slidesPerView: "auto",
      spaceBetween: 25,
      resizeObserver: true,
      threshold: 10,
      direction: "horizontal",
      touch: true,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: "#" + element.id + "-scroll",
        draggable: true,
      },
    });
    swipers.push(swiper);
  });
}
function destroySwipers() {
  swipers.forEach(function (swiper) {
    swiper.destroy();
  });
  swipers = [];
}
if (window.innerWidth >= 1024) {
  destroySwipers();
} else {
  initSwipers();
}
window.addEventListener("resize", function () {
  if (window.innerWidth >= 1024) {
    destroySwipers();
  } else {
    if (swipers.length === 0) {
      initSwipers();
    }
  }
});
if (document.getElementById("sizes-grid-button")) {
  const sizesGridButton = document.querySelectorAll("#sizes-grid-button");
  const sizesGridBackground = document.querySelectorAll("#sizes-grid-background");
  const sizesGrid = document.querySelectorAll("#sizes-grid");
  sizesGridButton.forEach((button, index) => {
    sizesGridBackground[index].onclick = (e) => {
      if (e.target.id == "sizes-grid-background" || e.target.id == "sizes-grid-exit") {
        sizesGrid[index].classList.add("tr-translate-y-[-300px]");
        sizesGridBackground[index].classList.remove("tr-opacity-100");
        sizesGridBackground[index].classList.add("tr-opacity-0");
        setTimeout(() => {
          sizesGridBackground[index].classList.add("!tr-hidden");
        }, 300);
      }
    };
    sizesGridButton[index].onclick = () => {
      sizesGridBackground[index].classList.remove("!tr-hidden", "tr-opacity-0");
      setTimeout(() => {
        sizesGrid[index].classList.remove("tr-translate-y-[-300px]");
        sizesGridBackground[index].classList.add("tr-opacity-100");
      }, 150);
    };
  });
}
let swipersbundleset = [];
function initSwipersBundleSet() {
  const swiperElements = document.querySelectorAll(".tr-bundle-set");
  swiperElements.forEach(function (element) {
    const swiper = new Swiper(element, {
      slidesPerView: "auto",
      threshold: 10,
    });
    swipersbundleset.push(swiper);
  });
}
function destroySwipersBundleSet() {
  swipersbundleset.forEach(function (swiper) {
    swiper.destroy();
  });
  swipersbundleset = [];
}
if (window.innerWidth <= 992) {
  destroySwipersBundleSet();
} else {
  initSwipersBundleSet();
}
window.addEventListener("resize", function () {
  if (window.innerWidth <= 992) {
    destroySwipersBundleSet();
  } else {
    if (swipersbundleset.length === 0) {
      initSwipersBundleSet();
    }
  }
});
